import { safeGet, safeSet } from './storage'

// Persisted user identity. Lives in localStorage so identification survives
// reloads and new tabs — the root cause of "sessions stay anonymous after
// login" was keeping userId only in the Analytics instance memory.
export const UID_KEY = '__uid'

export type StoredIdentity = {
  user_id: string
  id_prop?: string
  ts: number
}

export function loadIdentity(): StoredIdentity | null {
  const v = safeGet<StoredIdentity | null>(UID_KEY, null)
  if (!v || typeof v !== 'object') return null
  if (typeof v.user_id !== 'string' || !v.user_id) return null
  return v
}

export function saveIdentity(identity: StoredIdentity): void {
  safeSet(UID_KEY, identity)
}

export function clearIdentity(): void {
  try {
    localStorage.removeItem(UID_KEY)
  } catch {
    /* noop */
  }
}
